import React from 'react';
import PropTypes from 'prop-types';
import SectionNumber from '../../SectionNumber';
import InputContainer from '../../InputContainer';
import TextAreaAttribute from '../TextAreaAttribute';
import RulesContainer from '../RulesContainer';

export default function FieldCommonOverrideEditor({
  keyPath,
  uiState,
  values,
  validateAndChangeRulesContainerValue,
  validateAndChangeRequiredFieldValue,
  onFieldUIStateChange,
  standardFieldNameIsNull,
  requiredStandardField,
  disableRulesContainer,
  onFieldValueChange,
}) {

  const SECTIONOFFSET_ML = '-11%';

  return (
    <div className="row border-top border-secondary pb-3" style={{ marginLeft: SECTIONOFFSET_ML }}>
      <div className="col-1 p-0">
        <SectionNumber number="1B" />
      </div>
      <div className="col-11">
        <div className="row mb-4">
          <div className="col-sm-6 mt-3">
            <p className="mb-0 font-weight-bold">Implied Consent Overrides</p>
            <div className="mb-0 mt-2">
              <p>When a prospect is in a GDPR region, the phone field will become optional and help text will be displayed.</p>
            </div>
          </div>

          <div className="col-sm-6 mt-3">
            <InputContainer
              label="Override Display Name (optional)"
              keyPath={[...keyPath, 'overrides', 'gdpr', 'label']}
              uiState={uiState?.overrides?.gdpr?.label}
              disabled={standardFieldNameIsNull}
            >
              <TextAreaAttribute
                keyPath={[...keyPath, 'overrides', 'gdpr', 'label']}
                value={values?.overrides?.gdpr?.label || ''}
                disabled={standardFieldNameIsNull}
                onFieldValueChange={onFieldValueChange}
                onFieldUIStateChange={onFieldUIStateChange}
              />
            </InputContainer>
          </div>

          <div className="col-sm-12 mt-3">
            <InputContainer
              label="Required Help Text"
              keyPath={[...keyPath, 'overrides', 'gdpr', 'helpText', 'value']}
              uiState={uiState?.overrides?.gdpr?.helpText?.value}
              disabled={standardFieldNameIsNull}
            >
              <TextAreaAttribute
                keyPath={[...keyPath, 'overrides', 'gdpr', 'helpText', 'value']}
                value={values?.overrides?.gdpr?.helpText?.value || ''}
                disabled={standardFieldNameIsNull}
                onFieldValueChange={validateAndChangeRequiredFieldValue}
                onFieldUIStateChange={onFieldUIStateChange}
              />
            </InputContainer>
          </div>

          <div className="col-sm-6 mt-3">
            <RulesContainer
              disabled={disableRulesContainer}
              keyPath={[...keyPath, 'overrides', 'gdpr', 'rules']}
              onFieldValueChange={validateAndChangeRulesContainerValue}
              radioGroupName="Implied Consent Phone Rules"
              requiredStandardField={requiredStandardField}
              values={values?.overrides?.gdpr || {}}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
FieldCommonOverrideEditor.propTypes = {
  keyPath: PropTypes.array.isRequired,
  uiState: PropTypes.object,
  values: PropTypes.object,
  standardFieldNameIsNull: PropTypes.bool,
  validateAndChangeRequiredFieldValue: PropTypes.func.isRequired,
  validateAndChangeRulesContainerValue: PropTypes.func.isRequired,
  onFieldUIStateChange: PropTypes.func.isRequired,
  onFieldValueChange: PropTypes.func.isRequired,
  requiredStandardField: PropTypes.bool,
  disableRulesContainer: PropTypes.bool,
};
